export const categories = {
  earrings: {
    title: "Earrings Collection",
    banner: "/assets/images/slider/img-1.jpg",
  },
  rings: {
    title: "Rings Collection",
    banner: "/assets/banners/rings.jpg",
  },
};